import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CustomInvoiceConnector } from '../../../connectors/custom-invoice.connector';
import { InvoiceHistoryList } from '../../../invoices.model';
import { LOAD_INVOICES, LoadInvoices, LoadInvoicesFail, LoadInvoicesSuccess } from '../actions/custom-invoices-history.actions';

@Injectable()
export class CustomInvoicesHistoryEffects {
  protected logger = inject(LoggerService);
  loadInvoices$: Observable<LoadInvoicesSuccess | LoadInvoicesFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_INVOICES),
      map((actions: LoadInvoices) => actions.payload),
      switchMap(({ userId, pageSize, currentPage, sort, invoicesFilter }) => {
        return this.invoicesConnector.get(userId, pageSize, currentPage, sort, invoicesFilter).pipe(
          map((invoices: InvoiceHistoryList) => new LoadInvoicesSuccess(invoices)),
          catchError((error: any) => of(new LoadInvoicesFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  constructor(private actions$: Actions, private invoicesConnector: CustomInvoiceConnector) {}
}
